export enum PhoneTypeText {
  Landline = 'Landline',
  Cellphone = 'Cell phone'
}

export enum PhoneTypeKey {
  Landline = 'landline',
  Cellphone = 'cell'
}

export const phoneTypeOptions = [
  {key: PhoneTypeKey.Cellphone, value: PhoneTypeText.Cellphone},
  {key: PhoneTypeKey.Landline, value: PhoneTypeText.Landline}
];
